"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Carousel.scss");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _BoundedCard = _interopRequireDefault(require("../BoundedCard/BoundedCard"));
var _UnboundedCard = require("../UnboundedCard/UnboundedCard");
var _BioBlock = _interopRequireDefault(require("../BioBlock/BioBlock"));
var _FocusedImage = _interopRequireDefault(require("../FocusedImage/FocusedImage"));
var _PullQuote = _interopRequireDefault(require("../PullQuote/PullQuote"));
var _CarouselMethods = require("./CarouselMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
let Flickity;
if (typeof window !== "undefined") {
  Flickity = require("flickity");
}
const Carousel = _ref => {
  let {
    content,
    paddingClass,
    motion,
    theme,
    contentfulId,
    type
  } = _ref;
  const GatsbyImage = content?.GatsbyImage;
  const [cardsLoaded, setCardsLoaded] = (0, _react.useState)();
  const [slideCountMessage, setSlideCountMessage] = (0, _react.useState)(false);
  const el = (0, _react.useRef)(null);

  // This function determine the tallest item in the carousel to set the height for all items
  function calculateCarouselItemHeight(type) {
    if (typeof window !== "undefined") {
      let carouselItems = {
        bounded_cards: Array.from(document.querySelectorAll(".ter-bounded-card")),
        unbounded_cards: Array.from(document.querySelectorAll(".ter-unbounded-card")),
        bio_blocks: Array.from(document.querySelectorAll(".ter-bio-block")),
        pull_quotes: Array.from(document.querySelectorAll(".ter-pullQuote"))
      };
      const highest = Math.max(...carouselItems[type].map(item => item.getBoundingClientRect().height));
      return highest;
    }
  }

  // split all cards into grouped cells
  const largeCards = (0, _lodash.chunk)(content?.cards, 4);
  const mediumCards = (0, _lodash.chunk)(content?.cards, 3);
  const smallCards = (0, _lodash.chunk)(content?.cards, 2);
  const xSmallCards = (0, _lodash.chunk)(content?.cards, 1);
  (0, _react.useEffect)(() => {
    if (cardsLoaded) {
      let activeCarousel;
      el?.current?.querySelectorAll(".ter-carousel").forEach(carousel => {
        let totalSlides = carousel?.querySelectorAll(".flickity-cell").length;
        activeCarousel = new Flickity(carousel, {
          cellAlign: "center",
          wrapAround: true,
          adaptiveHeight: false,
          imagesLoaded: false,
          setGallerySize: false,
          on: {
            ready: function (index) {
              setSlideCountMessage(`Slide ${1} of ${content?.images?.length || content?.cards?.length}`);
            },
            change: function (index) {
              setSlideCountMessage(`Slide ${index + 1} of ${content?.images?.length || content?.cards?.length}`);
            }
          }
        });
      });
      document.querySelectorAll(".carousel-cell").forEach(elem => {
        elem.setAttribute("height", elem.clientHeight);
      });
    }
  }, [cardsLoaded]);
  (0, _react.useEffect)(() => {
    if (document) {
      setCardsLoaded(true);
      addPaginationLabels();
    }
  });
  (0, _react.useEffect)(() => {}, [content]);
  const addPaginationLabels = () => {
    if (document !== null) {
      let carouselPaginations = document?.querySelectorAll(".flickity-page-dots");
      carouselPaginations?.forEach(pagination => {
        if (pagination && pagination?.childNodes && pagination?.childNodes.length > 0) {
          pagination?.childNodes.forEach((element, i) => {
            element.tabIndex = 0;
            element.innerText = i + 1;
          });
        }
      });
    }
  };
  const skipCarousel = e => {
    if (document !== null) {
      e.preventDefault();
      let targetElem = document.querySelector(e.target.hash);
      if (targetElem) {
        targetElem.scrollIntoView();
      }
    }
  };
  const renderCarouselCardItems = (carouselCardItems, type) => {
    if (carouselCardItems && carouselCardItems.length) {
      return carouselCardItems.map((item, index) => {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "carousel-item",
          key: index
        }, item.map((card, index) => {
          const carouselItemContent = {
            locale: card?.locale,
            eyebrow: card?.eyebrow,
            header: card?.header,
            image: card?.image,
            imageSizes: _CarouselMethods.imageSizes,
            displayButton: content?.displayButton,
            cardLink: card?.cardLink,
            bgColor: !card?.image ? "grey" : "",
            text: card?.text,
            GatsbyImage: GatsbyImage,
            Link: content?.Link,
            cardAlignment: content?.cardAlignment
          };
          switch (type) {
            case "bounded_cards":
              return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_BoundedCard.default, {
                key: index,
                content: carouselItemContent,
                motion: motion ? motion : null,
                contentfulId: card?.contentfulId
              }));
            case "unbounded_cards":
              return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_UnboundedCard.UnboundedCard, {
                key: index,
                content: carouselItemContent,
                motion: motion ? motion : null,
                contentfulId: card?.contentfulId,
                height: calculateCarouselItemHeight(type)
              }));
            case "bio_blocks":
              return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_BioBlock.default, {
                key: index,
                content: carouselItemContent,
                motion: motion ? motion : null,
                contentfulId: card?.contentfulId,
                height: calculateCarouselItemHeight(type)
              }));
            default:
              return null;
          }
        }));
      });
    }
  };
  const renderCarouselCounter = () => {
    return /*#__PURE__*/_react.default.createElement("div", null, content?.images?.length || content?.cards?.length && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      className: `ter-carousel__skip`,
      tabIndex: "0",
      href: "#skip-link",
      onClick: e => skipCarousel(e)
    }, "Skip carousel of ", content?.cards?.length, " items"), /*#__PURE__*/_react.default.createElement("div", {
      className: "ter-carousel__counter"
    }, slideCountMessage && slideCountMessage)));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: el,
    className: `ter-carousel-outer ter-carousel-outer--${theme}`,
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, type && type === "focal_point_images" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--focal-point ${paddingClass}`,
    height: "100%"
  }, (0, _CarouselMethods.renderCarouselImageItems)(content))) : type && type === "pull_quotes" ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderCarouselCounter(), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--pull-quote ${paddingClass}`,
    height: "100%"
  }, (0, _CarouselMethods.renderCarouselPullQuoteItems)(content, calculateCarouselItemHeight(type)))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, renderCarouselCounter(), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--large ${paddingClass}`,
    height: "100%"
  }, renderCarouselCardItems(largeCards, type)), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--medium ${paddingClass}`,
    height: "100%"
  }, renderCarouselCardItems(mediumCards, type)), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--small ${paddingClass}`,
    height: "100%"
  }, renderCarouselCardItems(smallCards, type)), /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-carousel ter-carousel--xsmall ${paddingClass}`,
    height: "100%"
  }, renderCarouselCardItems(xSmallCards, type))), /*#__PURE__*/_react.default.createElement("span", {
    id: "skip-link"
  })));
};
var _default = Carousel;
exports.default = _default;
Carousel.propTypes = {
  content: _propTypes.default.shape({
    cards: _propTypes.default.arrayOf(_propTypes.default.shape({
      image: _propTypes.default.shape({
        focalPointImage: _propTypes.default.object
      }),
      GatsbyImage: _propTypes.default.bool,
      eyebrow: _propTypes.default.string,
      header: _propTypes.default.string.isRequired,
      text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
      cardLink: _propTypes.default.shape({
        text: _propTypes.default.string.isRequired,
        url: _propTypes.default.string.isRequired
      }),
      bgColor: _propTypes.default.string,
      displayButton: _propTypes.default.bool,
      cardAlignment: _propTypes.default.bool
    })),
    type: _propTypes.default.string,
    displayButton: _propTypes.default.bool,
    cardAlignment: _propTypes.default.bool
  }),
  motion: _propTypes.default.bool,
  theme: _propTypes.default.string
};